import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=5cffa81e&scoped=true&"
import script from "./ForwardMessage.vue?vue&type=script&lang=ts&"
export * from "./ForwardMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&id=5cffa81e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffa81e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
